import { Box, Button, Link, makeStyles, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BuzzModal from '../../../components/BuzzModal/BuzzModal';
import useLoader from '../../../hooks/useLoader';
import useToast from '../../../hooks/useToast';
import moment from 'moment';
import {
  commonApprovalAsync,
  getApprovalListAsync,
} from '../ApprovalStore/approvalSlice';
import BuzzImage from '../../../components/BuzzImage/BuzzImage';

const useStyles = makeStyles((theme) => ({
  multiLineEllipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
  },
  linkTextStyle: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    '&:active': {
      opacity: 0.7,
    },
  },
  img: {
    height: 300,
    width: 300,
  },
}));

const StoryApprovalModal = ({ data, open = false, onClose = '' }) => {
  const classes = useStyles();
  const { handleLoader } = useLoader();
  const { SuccessToast, ErrorToast } = useToast();
  const dispatch = useDispatch();
  const [showMore, setShowMore] = useState(false);

  const { storyApprovalDetails, storyDetails } = useSelector(
    ({ approvalReducer }) => {
      return {
        storyApprovalDetails: approvalReducer.commonOneApprovalDetails,
        storyDetails: approvalReducer.storyDetails,
      };
    }
  );

  const handleShowMore = () => {
    setShowMore((prevState) => !prevState);
  };

  const showMoreText = showMore ? 'See less..' : 'See More';

  const handleApprove = () => {
    handleLoader(true);
    dispatch(
      commonApprovalAsync({
        _id: storyApprovalDetails._id,
        bodyData: { action: 'approved' },
      })
    )
      .unwrap()
      .then((res) => {
        console.log({ res });
        dispatch(
          getApprovalListAsync({
            params: {
              entityType: 'article',
              approvalType: 'article-status',
              limit: 10,
              page: 1,
              statuses: ['pending'],
            },
            type: 'common',
          })
        );
        SuccessToast('Approved!');
      })
      .catch((error) => {
        ErrorToast(error.message);
      })
      .finally(() => {
        handleLoader(false);
        onClose();
      });
  };

  const handleDisapprove = () => {
    handleLoader(true);
    dispatch(
      commonApprovalAsync({
        _id: storyApprovalDetails._id,
        bodyData: { action: 'disapprove' },
      })
    )
      .unwrap()
      .then((res) => {
        console.log({ res });
        dispatch(
          getApprovalListAsync({
            params: {
              entityType: 'article',
              approvalType: 'article-status',
              limit: 10,
              page: 1,
              statuses: ['pending'],
            },
            type: 'common',
          })
        );
        SuccessToast('Disapproved!');
      })
      .catch((error) => {
        ErrorToast(error.message);
      })
      .finally(() => {
        handleLoader(false);
        onClose();
      });
  };

  return (
    <BuzzModal
      width={'80vw'}
      open={open}
      title={`Story Details`}
      onClose={onClose}>
      <Box
        fontFamily={'Rubik'}
        display="flex"
        flexDirection={'column'}
        justifyContent="space-between"
        minHeight={'50vh'}>
        <Box>
          <Box mb={4}>
            <Box mb={4} maxWidth={'70vw'}>
              <Box
                fontSize={20}
                fontWeight="fontWeightMedium"
                sx={{ textDecoration: 'underline' }}
                mb={1}>
                Story Title
              </Box>
              <Box mb={2}>
                <Typography variant="body2" component="div">
                  {data && data.title
                    ? data && data.title
                    : storyDetails && storyDetails.title}
                </Typography>
              </Box>
              <Box
                fontSize={20}
                fontWeight="fontWeightMedium"
                sx={{ textDecoration: 'underline' }}
                mb={1}>
                Story Image
              </Box>
              <Box
                display={'flex'}
                flexWrap="wrap"
                justifyContent={'flex-start'}>
                {data && data.imageFullUrls && Array.isArray(data.imageFullUrls)
                  ? data &&
                    data.imageFullUrls.map((img, idx) => (
                      <Box key={img} mr={2}>
                        <BuzzImage
                          src={img}
                          alt="storyImage"
                          className={classes.img}
                        />
                        <Box mt={1} textAlign="center">
                          Image - {idx + 1}
                        </Box>
                      </Box>
                    ))
                  : storyDetails &&
                    Array.isArray(storyDetails.imageLink) &&
                    storyDetails.imageLink.map((img, idx) => (
                      <Box key={img} mr={2}>
                        <BuzzImage
                          src={img}
                          alt="storyImage"
                          className={classes.img}
                        />
                        <Box mt={1} textAlign="center">
                          Image - {idx + 1}
                        </Box>
                      </Box>
                    ))}
              </Box>
              {data && (
                <Box mb={2} display={'flex'}>
                  <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                    Type:
                  </Box>
                  <Box fontSize={16}>{data.type}</Box>
                </Box>
              )}
              <Box
                fontSize={20}
                fontWeight="fontWeightMedium"
                sx={{ textDecoration: 'underline' }}
                mb={1}>
                Story details
              </Box>
              {data && data.article ? (
                <>
                  {!showMore &&
                  data &&
                  data.article &&
                  data.article.length >= 150
                    ? data &&
                      data.article &&
                      data.article.substring(0, 150) + '...'
                    : data && data.article}{' '}
                  &nbsp;
                  {data && data.article && data.article.length >= 150 && (
                    <Link
                      color="primary"
                      underline="always"
                      className={classes.linkTextStyle}
                      onClick={handleShowMore}>
                      {showMoreText}
                    </Link>
                  )}
                </>
              ) : (
                <>
                  {storyDetails && (
                    <Box mb={2}>
                      <Typography
                        variant="body2"
                        component="div"
                        className={!showMore ? classes.multiLineEllipsis : ''}>
                        {!showMore &&
                        storyDetails &&
                        storyDetails.article.length >= 150
                          ? storyDetails &&
                            storyDetails.article.substring(0, 150) + '...'
                          : storyDetails && storyDetails.article}{' '}
                        {storyDetails && storyDetails.article.length >= 150 && (
                          <Link
                            color="primary"
                            underline="always"
                            className={classes.linkTextStyle}
                            onClick={handleShowMore}>
                            {showMoreText}
                          </Link>
                        )}
                      </Typography>
                    </Box>
                  )}
                </>
              )}
            </Box>
            {data && (
              <Box mb={2} display={'flex'}>
                <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                  Up Votes:
                </Box>
                <Box fontSize={16}>{data.upvotes} &nbsp; &nbsp;</Box>
                <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                  View Counts:
                </Box>
                <Box fontSize={16}>{data.viewCount}</Box>
              </Box>
            )}
            <Box mb={2} display={'flex'}>
              <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                Status:
              </Box>
              <Box fontSize={16}>
                {data && data.articleStatus
                  ? data && data.articleStatus
                  : storyApprovalDetails && storyApprovalDetails.status}
              </Box>
            </Box>
            {data && (
              <>
                <Box mb={2} display={'flex'}>
                  <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                    Submitted By:
                  </Box>
                  <Box fontSize={16}>{data.submittedBy}</Box>
                </Box>
                <Box mb={2} display={'flex'}>
                  <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                    HashTags:
                  </Box>
                  {data &&
                    Array.isArray(data.hashTags) &&
                    data.hashTags.map((hashTag) => (
                      <Box key={hashTag} mr={2}>
                        <Box textAlign="center">{hashTag},</Box>
                      </Box>
                    ))}
                </Box>
              </>
            )}
            <Box mb={2} display={'flex'}>
              <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                Created at:
              </Box>
              <Box fontSize={16}>
                {moment(
                  data && data.createdAt
                    ? data && data.createdAt
                    : storyApprovalDetails && storyApprovalDetails.createdAt
                ).format('MMMM Do, YYYY')}
              </Box>
            </Box>
            <Box mb={2} display={'flex'}>
              <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                Updated at:
              </Box>
              <Box fontSize={16}>
                {moment(
                  data && data.updatedAt
                    ? data && data.updatedAt
                    : storyApprovalDetails && storyApprovalDetails.updatedAt
                ).format('MMMM Do, YYYY')}
              </Box>
            </Box>
          </Box>
        </Box>
        {data && data.updatedAt ? null : (
          <Box
            borderTop={1}
            borderColor="#dfdfdf"
            pt={3}
            mb={2}
            display="flex"
            alignItems="flex-end"
            justifyContent="flex-end">
            <Box mr={1}>
              <Button
                disabled={
                  (storyApprovalDetails &&
                    storyApprovalDetails.status === 'rejected') ||
                  (storyApprovalDetails &&
                    storyApprovalDetails.status === 'approved')
                }
                mr={1}
                variant="contained"
                color="primary"
                onClick={handleApprove}>
                Approve
              </Button>
            </Box>
            <Button
              disabled={
                (storyApprovalDetails &&
                  storyApprovalDetails.status === 'rejected') ||
                (storyApprovalDetails &&
                  storyApprovalDetails.status === 'approved')
              }
              onClick={() => {
                onClose();
                handleDisapprove();
              }}
              color="primary"
              variant="outlined">
              Disapprove
            </Button>
          </Box>
        )}
      </Box>
    </BuzzModal>
  );
};

export default StoryApprovalModal;
